import { api, apiFile } from "api/api";
import { AxiosError } from "axios";
import ItemInspecaoFrota from "model/gestao/frotas/ItemInspecaoFrota";
import MarcaVeiculo from "model/gestao/frotas/MarcaVeiculo";
import Veiculo from "model/gestao/frotas/Veiculo";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { generateKey } from "utils/generateKey";

class ManutencaoPendenteService implements BaseServiceCadastros<Veiculo> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta|null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/veiculo/manutencaoPendente/pesquisar`;
            url+= getFilters(filters);
            
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Veiculo>((resolve, reject): void => {});
    }

    incluir(veiculo: Veiculo) {
        return new Promise<Veiculo>((resolve, reject): void => {});
    }

    editar(veiculo: Veiculo) {
        return new Promise<Veiculo>((resolve, reject): void => {});
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {});
    }
}

export default ManutencaoPendenteService;